<template>
  <v-container fluid>
    <v-data-table-server
      :headers="headers"
      :items="sapgCustoms"
      :search="search"
      density="compact"
      :items-length="totalItems"
      :loading="loadingDatatables"
      @update:sortBy="toSort"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-text-field
            v-model="search"
            density="compact"
            :label="this.$t('search')"
            class="pl-2"
            :prepend-inner-icon="mdiMagnify"
            @update:modelValue="toSearchBack"
            variant="solo-filled"
            flat
            hide-details
            single-line
          ></v-text-field>
          <v-spacer></v-spacer>
          <v-btn
            variant="elevated"
            class="mb-2 text-white mr-3"
            :prepend-icon="mdiAccountPlus"
            color="#ffb300"
            @click="openDialog"
            dark
          >
            {{ $t("admin.new-sapg-custom") }}
          </v-btn>
        </v-toolbar>
      </template>

      <template v-slot:item.actions="{ item }">
        <v-icon class="me-2" size="small" @click="editItem(item)">
          {{ mdiPencil }}
        </v-icon>
        <v-icon size="small" @click="deleteItem(item)">
          {{ mdiDelete }}
        </v-icon>
      </template>

      <template v-slot:bottom>
        <pagination-dynamic :store="'sapgCustoms'"></pagination-dynamic>
      </template>
    </v-data-table-server>
    <add-edit-sapg-custom
      :modelDialog="sapgCustomDialog"
      @close="sapgCustomDialog = false"
    ></add-edit-sapg-custom>
  </v-container>
</template>

<script>
import { mdiPencil, mdiDelete, mdiMagnify, mdiAccountPlus } from "@mdi/js";
import PaginationDynamic from "@/components/PaginationDynamic.vue";
import AddEditSapgCustom from "./admin/AddEditSapgCustom.vue";
import paginate from "@/mixins/paginations";
import { mapState } from "vuex";

export default {
  name: "SapgCustomAdmin",
  components: { AddEditSapgCustom, PaginationDynamic },
  mixins: [paginate],
  data() {
    return {
      mdiAccountPlus,
      mdiMagnify,
      mdiPencil,
      mdiDelete,
      dialog: false,
      dialogDelete: false,
      sapgCustomDialog: false,
      itemsPerPage: 15,
      page: 1,
      headers: [
        { title: "Nom", key: "name" },
        { title: "Actions", key: "actions", sortable: false, align: "end" }
      ]
    };
  },
  computed: {
    ...mapState({
      sapgCustoms: (state) => state.sapgCustoms.items,
      loadingDatatables: (state) => state.loadingTables,
      totalItems: (state) => state.paginations.totalCount,
      editedId: (state) => state.sapgCustoms.editedId
    }),
    pageCount() {
      return Math.ceil(this.sapgCustoms.length / this.itemsPerPage);
    },
    search: {
      get() {
        return this.$store.state.paginations.search;
      },
      set(value) {
        this.$store.commit("paginations/setSearch", value);
      }
    }
  },
  methods: {
    toSort(item) {
      this.sortBy(item, "sapgCustoms");
    },
    toSearchBack(value, time = 500) {
      this.searchBack(value, time, "sapgCustoms");
    },
    openDialog() {
      this.$store.commit("sapgCustoms/setEditedId", -1);
      this.$store.commit("sapgCustoms/setEditedItem", Object.assign({}, {}));
      this.sapgCustomDialog = true;
    },
    editItem(item) {
      this.$store.commit("sapgCustoms/setEditedId", item.id);
      this.$store.commit("sapgCustoms/setEditedItem", Object.assign({}, item));
      this.sapgCustomDialog = true;
    },
    deleteItem(item) {
      if (confirm(this.$t("alert.delete.sapg-custom"))) {
        this.$store
          .dispatch("sapgCustoms/deleteItem", item.id)
          .then(() => {
            this.$store.dispatch("showSnackbar", {
              message: this.$t("alert.success.sapg-custom-delete"),
              color: "success"
            });
            this.toSearchBack(this.search, 500, "sapgCustoms");
          })
          .catch(() => {
            this.$store.dispatch("showSnackbar", {
              message: this.$t("alert.error.sapg-custom-delete"),
              color: "error"
            });
          });
      }
    }
  }
};
</script>
